.progressBarContainer {
    display: flex;
    gap: 2px;
    height: 12px;
    background-color: transparent;
}

.progressBarSegmentIncomplete {
    background-color: var(--hps-light-gray);
}

.progressBarSegmentComplete {
    background-color: var(--hps-dark-gray)
}

.tooltipContent {
    display: flex;
    flex-direction: column;
    gap: 5px;
}

.tooltipRow {
    display: flex;
    gap: 5px;
    align-items: center;
}

.tooltipIcon {
    color: var(--hps-white);
}

.progressBarAndText {
    display: flex;
    flex-direction: column;
    gap: 2px;
}

.progressText {
    text-align: left;
}

.primaryTextAndSecondaryText {
    display: flex;
    flex-direction: column;
}